import React from 'react';
import Modal from '../../../commonComponents/util/Modal';
import Select from '../../../commonComponents/util/Select';
import LoadingSpinner from '../../../commonComponents/util/LoadingSpinner';
import ValidatedInput from '../../../commonComponents/util/ValidatedInput';
import FadeOutErrorMessage from '../../../commonComponents/util/FadeOutErrorMessage';


export default class CampaignCategoryModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            campaign: {
                name: '',
                campaignType: ''
            },
            error: false,
            submitAttempted: false
        }

        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onClose = this.onClose.bind(this);
    }

    onChange(name, value) {
        this.setState({ campaign: { ...this.state.campaign, ...{ [name]: value } } });
    }

    async onSubmit() {
        this.setState({ error: false, submitAttempted: true });
        const campaign = this.state.campaign;
        if (!campaign.name || !campaign.campaignType) return;
        await this.props.addCategory(this.state.campaign);
        if (this.props.success) this.onClose();
        else this.setState({ error: true });
    }

    onClose() {
        this.props.close();
        this.setState({
            campaign: {
                name: '',
                campaignType: ''
            },
            error: false,
            submitAttempted: false
        });
    }

    render() {
        let campaign = this.state.campaign;
        return (

            <Modal modalShowing={this.props.show}>
            
                <div className="modal-container">
                    <div className="modal new-transaction-modal large-modal">
                        <div className="modal-header">
                            <h4 className="page-header">Create Campaign Category</h4>
                            <i className="icon ion-ios-close-empty" onClick={this.onClose}></i>
                        </div>

                        <div className="modal-section">
                            <div className="modal-row">
                                <div className="column-half">
                                    <ValidatedInput input={<input type="text" />}
                                        label="Campaign Category Name" name="name" value={campaign.name} onChange={this.onChange}
                                        required={true} showRequiredError={this.state.submitAttempted} />
                                </div>
                                <div className="column-half">
                                    <ValidatedInput input={<Select clearable={true} options={this.props.campaignTypes} />}
                                        label="Type" name="campaignType" value={campaign.campaignType} onChange={this.onChange}
                                        required={true} showRequiredError={this.state.submitAttempted} />
                                </div>
                            </div>
                        </div>

                        {this.props.loading ? <LoadingSpinner height="20" alignRight={true} /> :
                            <div className="modal-btns text-right">
                                <button className="btn btn-accent" onClick={this.onClose}>Cancel</button>
                                <button className="btn btn-primary" onClick={this.onSubmit}>Save</button>
                                <FadeOutErrorMessage show={this.state.error}/>
                            </div>}
                    </div>
                </div>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/settingComponents/systemSettings/campaignSettings/CampaignCategoryModal.jsx